import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ReactTooltip from 'react-tooltip';
import FileUpload from './FileUpload.jsx'
import DropDown from './DropDown.jsx'

const OnSiteFile = props => (
    <div className="form-input-container">
        <div ><b></b></div>
        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>OnSite Latitude</InputLabel>
            <Input
                data-tip data-for="osLat"
                inputProps={{ min: "-90", max: "90", step: "any" }}
                type="number"
                name="osLat"
                value={props.osLat}
                onChange={props.handleInputChange}/>
        </FormControl>
        <ReactTooltip id='osLat' place="bottom" type="light" effect="solid">
            Onsite surface station latitude in decimal degrees from -90 to 90.
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>OnSite Longitude</InputLabel>
            <Input
                data-tip data-for="osLon"
                inputProps={{ min: "-180", max: "180", step: "any" }}
                type="number"
                name="osLon"
                value={props.osLon}
                onChange={props.handleInputChange}/>
        </FormControl>
        <ReactTooltip id='osLon' place="bottom" type="light" effect="solid">
            Onsite surface station longitude in decimal degrees from -180 to 180.
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>OnSite Elevation (m)</InputLabel>
            <Input
                data-tip data-for="osElev"
                inputProps={{ min: "0", max: "9999", step: "any" }}
                type="number"
                name="osElev"
                value={props.osElev}
                onChange={props.handleInputChange}/>
        </FormControl>
        <ReactTooltip id='osElev' place="bottom" type="light" effect="solid">
            Onsite elevaion above ground in meters.
        </ReactTooltip>
    </div>
)
export default OnSiteFile;
